<style lang="scss" scoped>
@import './../../assets/style-colors.scss';

.light-blue {
  color: $light-blue;
  font-size: 16px;
  font-weight: bold;
}
</style>

<template>
  <b-modal v-model="show" no-close-on-esc no-fade size="lg">
    <div slot="modal-title">
      <h6>Soldto Tag</h6>
    </div>

    <b-container fluid>
      <b-form-row>
        <b-col cols="8">
          <b-input-group>
            <b-form-input v-model="input" placeholder="Enter soldto ID" @keyup.enter="getSoldto" />

            <template #append>
              <b-btn variant="secondary" @click="getSoldto"> Search </b-btn>
            </template>
          </b-input-group>
        </b-col>
      </b-form-row>

      <div v-if="warning" class="mt-4">
        <b-form-row>
          <b-col>
            <b-alert dismissible show variant="warning"> Soldto not found </b-alert>
          </b-col>
        </b-form-row>
      </div>

      <b-form-row v-if="soldto != null" class="mt-4">
        <b-col cols="12">
          <b-card>
            <b-form-row>
              <b-col cols="6">
                <span class="text-primary"
                  ><strong>{{ soldto.id }} - {{ soldto.name }}</strong></span
                >
              </b-col>
            </b-form-row>

            <b-form-row class="mt-2">
              <b-col cols="3">
                <span class="d-flex flex-column">
                  <label class="mb-0"><small>Customer No.</small></label>
                </span>
                {{ soldto.customer.number }}
              </b-col>

              <b-col cols="3">
                <span class="d-flex flex-column">
                  <label class="mb-0"><small>Customer Group</small></label>
                </span>
                {{ soldto.customer.group }}
              </b-col>

              <b-col cols="2">
                <span class="d-flex flex-column">
                  <label class="mb-0">
                    <small><i aria-hidden="true" class="fa fa-circle fa-fw text-danger" />Red</small>
                  </label>
                </span>
                <b-form-checkbox />
              </b-col>

              <b-col cols="2">
                <span class="d-flex flex-column">
                  <label class="mb-0">
                    <small><i aria-hidden="true" class="fa fa-circle fa-fw text-success" />Green</small>
                  </label>
                </span>
                <b-form-checkbox />
              </b-col>
            </b-form-row>
          </b-card>
        </b-col>
      </b-form-row>
    </b-container>

    <div slot="modal-footer">
      <b-btn variant="primary"> Save </b-btn>
      <b-btn class="ml-1"> Cancel </b-btn>
    </div>
  </b-modal>
</template>

<script>
import store from '@/store/store'
import api from '@/lib/api'

export default {
  data() {
    return {
      input: '',
      soldto: null,

      warning: false,
    }
  },
  computed: {
    show: {
      get() {
        return store.state.soldto.show
      },
      set(b) {
        store.commit('soldto/show', b)
      },
    },
  },
  methods: {
    async getSoldto() {
      if (!this.input) return

      this.warning = false

      try {
        const resp = await api.soldto.get(this.input)
        this.soldto = resp.data
      } catch (e) {
        this.warning = true
        this.soldto = null
      }
    },
  },
  created() {},
}
</script>
